import { render, staticRenderFns } from "./TreeNoteDocCat.vue?vue&type=template&id=0db8c170&scoped=true"
import script from "./TreeNoteDocCat.vue?vue&type=script&lang=js"
export * from "./TreeNoteDocCat.vue?vue&type=script&lang=js"
import style0 from "./TreeNoteDocCat.vue?vue&type=style&index=0&id=0db8c170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8c170",
  null
  
)

export default component.exports